var _defs, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStafihub(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1138px",
    height: "99px",
    viewBox: "0 0 1138 99",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    y1: 0.7461345,
    x2: 1,
    y2: 0.7461345,
    id: "gradient_1"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#6758FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "50.397526%",
    stopColor: "#6758FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "52.39504%",
    stopColor: "#FF7FA7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#FF7FA7"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 39.2778C0 39.2778 284.5 0 569 0C853.5 0 1138 39.2778 1138 39.2778L1138 99C1138 99 853.5 49.5 569 49.5C284.5 49.5 0 99 0 99L0 39.2778Z",
    id: "Rectangle-15",
    fill: "url(#gradient_1)",
    fillRule: "evenodd",
    stroke: "none"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStafihub);
export default __webpack_public_path__ + "static/media/stafihub.833c2dafae221a6942ba04376840d2e2.svg";
export { ForwardRef as ReactComponent };